__turbopack_context__.v({
  "bi": "icons-module-scss-module__yaMlSa__bi",
  "bi-123": "icons-module-scss-module__yaMlSa__bi-123",
  "bi-action-bookmark": "icons-module-scss-module__yaMlSa__bi-action-bookmark",
  "bi-action-bookmark-fill": "icons-module-scss-module__yaMlSa__bi-action-bookmark-fill",
  "bi-action-equal": "icons-module-scss-module__yaMlSa__bi-action-equal",
  "bi-action-gear": "icons-module-scss-module__yaMlSa__bi-action-gear",
  "bi-action-heart": "icons-module-scss-module__yaMlSa__bi-action-heart",
  "bi-action-refresh": "icons-module-scss-module__yaMlSa__bi-action-refresh",
  "bi-action-search": "icons-module-scss-module__yaMlSa__bi-action-search",
  "bi-action-tick": "icons-module-scss-module__yaMlSa__bi-action-tick",
  "bi-action-tick-circle": "icons-module-scss-module__yaMlSa__bi-action-tick-circle",
  "bi-action-tick-circle-fill": "icons-module-scss-module__yaMlSa__bi-action-tick-circle-fill",
  "bi-action-view": "icons-module-scss-module__yaMlSa__bi-action-view",
  "bi-action-wrench": "icons-module-scss-module__yaMlSa__bi-action-wrench",
  "bi-alert-bell": "icons-module-scss-module__yaMlSa__bi-alert-bell",
  "bi-alert-info": "icons-module-scss-module__yaMlSa__bi-alert-info",
  "bi-alert-info-fill": "icons-module-scss-module__yaMlSa__bi-alert-info-fill",
  "bi-arrow-down": "icons-module-scss-module__yaMlSa__bi-arrow-down",
  "bi-arrow-left": "icons-module-scss-module__yaMlSa__bi-arrow-left",
  "bi-arrow-right": "icons-module-scss-module__yaMlSa__bi-arrow-right",
  "bi-arrow-up": "icons-module-scss-module__yaMlSa__bi-arrow-up",
  "bi-caret-down-fill": "icons-module-scss-module__yaMlSa__bi-caret-down-fill",
  "bi-caret-left-fill": "icons-module-scss-module__yaMlSa__bi-caret-left-fill",
  "bi-caret-right-fill": "icons-module-scss-module__yaMlSa__bi-caret-right-fill",
  "bi-caret-up-fill": "icons-module-scss-module__yaMlSa__bi-caret-up-fill",
  "bi-carret-down-circle-fill": "icons-module-scss-module__yaMlSa__bi-carret-down-circle-fill",
  "bi-check-circle": "icons-module-scss-module__yaMlSa__bi-check-circle",
  "bi-check-circle-fill": "icons-module-scss-module__yaMlSa__bi-check-circle-fill",
  "bi-check-square": "icons-module-scss-module__yaMlSa__bi-check-square",
  "bi-check-square-empty": "icons-module-scss-module__yaMlSa__bi-check-square-empty",
  "bi-check-square-fill": "icons-module-scss-module__yaMlSa__bi-check-square-fill",
  "bi-check-square-minus": "icons-module-scss-module__yaMlSa__bi-check-square-minus",
  "bi-clock-fill": "icons-module-scss-module__yaMlSa__bi-clock-fill",
  "bi-cloud-fill": "icons-module-scss-module__yaMlSa__bi-cloud-fill",
  "bi-cloud-rain-fill": "icons-module-scss-module__yaMlSa__bi-cloud-rain-fill",
  "bi-cloud-sun-fill": "icons-module-scss-module__yaMlSa__bi-cloud-sun-fill",
  "bi-edit-duplicate": "icons-module-scss-module__yaMlSa__bi-edit-duplicate",
  "bi-edit-edit": "icons-module-scss-module__yaMlSa__bi-edit-edit",
  "bi-edit-link": "icons-module-scss-module__yaMlSa__bi-edit-link",
  "bi-edit-minus": "icons-module-scss-module__yaMlSa__bi-edit-minus",
  "bi-edit-plus": "icons-module-scss-module__yaMlSa__bi-edit-plus",
  "bi-edit-sort": "icons-module-scss-module__yaMlSa__bi-edit-sort",
  "bi-envelope-fill": "icons-module-scss-module__yaMlSa__bi-envelope-fill",
  "bi-fullscreen": "icons-module-scss-module__yaMlSa__bi-fullscreen",
  "bi-fullscreen-exit": "icons-module-scss-module__yaMlSa__bi-fullscreen-exit",
  "bi-general-clock-fill": "icons-module-scss-module__yaMlSa__bi-general-clock-fill",
  "bi-general-envelope-fill": "icons-module-scss-module__yaMlSa__bi-general-envelope-fill",
  "bi-general-geo-alt-fill": "icons-module-scss-module__yaMlSa__bi-general-geo-alt-fill",
  "bi-general-info-circle-fill": "icons-module-scss-module__yaMlSa__bi-general-info-circle-fill",
  "bi-general-people-fill": "icons-module-scss-module__yaMlSa__bi-general-people-fill",
  "bi-general-telephone-fill": "icons-module-scss-module__yaMlSa__bi-general-telephone-fill",
  "bi-geo-alt-fill": "icons-module-scss-module__yaMlSa__bi-geo-alt-fill",
  "bi-grid-3x3-gap-fill": "icons-module-scss-module__yaMlSa__bi-grid-3x3-gap-fill",
  "bi-info-circle-fill": "icons-module-scss-module__yaMlSa__bi-info-circle-fill",
  "bi-lightning-charge-fill": "icons-module-scss-module__yaMlSa__bi-lightning-charge-fill",
  "bi-list": "icons-module-scss-module__yaMlSa__bi-list",
  "bi-list-check": "icons-module-scss-module__yaMlSa__bi-list-check",
  "bi-moon-stars-fill": "icons-module-scss-module__yaMlSa__bi-moon-stars-fill",
  "bi-nav-arrow-down": "icons-module-scss-module__yaMlSa__bi-nav-arrow-down",
  "bi-nav-arrow-left": "icons-module-scss-module__yaMlSa__bi-nav-arrow-left",
  "bi-nav-arrow-right": "icons-module-scss-module__yaMlSa__bi-nav-arrow-right",
  "bi-nav-arrow-up": "icons-module-scss-module__yaMlSa__bi-nav-arrow-up",
  "bi-nav-caret-down": "icons-module-scss-module__yaMlSa__bi-nav-caret-down",
  "bi-nav-caret-down-fill": "icons-module-scss-module__yaMlSa__bi-nav-caret-down-fill",
  "bi-nav-caret-left": "icons-module-scss-module__yaMlSa__bi-nav-caret-left",
  "bi-nav-caret-left-fill": "icons-module-scss-module__yaMlSa__bi-nav-caret-left-fill",
  "bi-nav-caret-right": "icons-module-scss-module__yaMlSa__bi-nav-caret-right",
  "bi-nav-caret-right-fill": "icons-module-scss-module__yaMlSa__bi-nav-caret-right-fill",
  "bi-nav-caret-up": "icons-module-scss-module__yaMlSa__bi-nav-caret-up",
  "bi-nav-caret-up-fill": "icons-module-scss-module__yaMlSa__bi-nav-caret-up-fill",
  "bi-nav-carret-down-circle": "icons-module-scss-module__yaMlSa__bi-nav-carret-down-circle",
  "bi-nav-carret-down-circle-fill": "icons-module-scss-module__yaMlSa__bi-nav-carret-down-circle-fill",
  "bi-nav-fullscreen": "icons-module-scss-module__yaMlSa__bi-nav-fullscreen",
  "bi-nav-fullscreen-exit": "icons-module-scss-module__yaMlSa__bi-nav-fullscreen-exit",
  "bi-nav-grid": "icons-module-scss-module__yaMlSa__bi-nav-grid",
  "bi-nav-grid-fill": "icons-module-scss-module__yaMlSa__bi-nav-grid-fill",
  "bi-nav-list": "icons-module-scss-module__yaMlSa__bi-nav-list",
  "bi-nav-three-dots": "icons-module-scss-module__yaMlSa__bi-nav-three-dots",
  "bi-nav-three-dots-vertical": "icons-module-scss-module__yaMlSa__bi-nav-three-dots-vertical",
  "bi-nav-x": "icons-module-scss-module__yaMlSa__bi-nav-x",
  "bi-nav-x-circle-fill": "icons-module-scss-module__yaMlSa__bi-nav-x-circle-fill",
  "bi-nav-x-lg": "icons-module-scss-module__yaMlSa__bi-nav-x-lg",
  "bi-people-fill": "icons-module-scss-module__yaMlSa__bi-people-fill",
  "bi-share-fill": "icons-module-scss-module__yaMlSa__bi-share-fill",
  "bi-social-fb": "icons-module-scss-module__yaMlSa__bi-social-fb",
  "bi-social-in": "icons-module-scss-module__yaMlSa__bi-social-in",
  "bi-social-tw": "icons-module-scss-module__yaMlSa__bi-social-tw",
  "bi-social-yt": "icons-module-scss-module__yaMlSa__bi-social-yt",
  "bi-star": "icons-module-scss-module__yaMlSa__bi-star",
  "bi-star-fill": "icons-module-scss-module__yaMlSa__bi-star-fill",
  "bi-star-half": "icons-module-scss-module__yaMlSa__bi-star-half",
  "bi-sun-fill": "icons-module-scss-module__yaMlSa__bi-sun-fill",
  "bi-svg-fb": "icons-module-scss-module__yaMlSa__bi-svg-fb",
  "bi-svg-ins": "icons-module-scss-module__yaMlSa__bi-svg-ins",
  "bi-svg-tw": "icons-module-scss-module__yaMlSa__bi-svg-tw",
  "bi-svg-yt": "icons-module-scss-module__yaMlSa__bi-svg-yt",
  "bi-telephone-fill": "icons-module-scss-module__yaMlSa__bi-telephone-fill",
  "bi-three-dots": "icons-module-scss-module__yaMlSa__bi-three-dots",
  "bi-three-dots-vertical": "icons-module-scss-module__yaMlSa__bi-three-dots-vertical",
  "bi-toggle-check-circle": "icons-module-scss-module__yaMlSa__bi-toggle-check-circle",
  "bi-toggle-check-circle-fill": "icons-module-scss-module__yaMlSa__bi-toggle-check-circle-fill",
  "bi-toggle-check-square": "icons-module-scss-module__yaMlSa__bi-toggle-check-square",
  "bi-toggle-check-square-fill": "icons-module-scss-module__yaMlSa__bi-toggle-check-square-fill",
  "bi-toggle-check-square-minus": "icons-module-scss-module__yaMlSa__bi-toggle-check-square-minus",
  "bi-toggle-share": "icons-module-scss-module__yaMlSa__bi-toggle-share",
  "bi-toggle-share-fill": "icons-module-scss-module__yaMlSa__bi-toggle-share-fill",
  "bi-toggle-star": "icons-module-scss-module__yaMlSa__bi-toggle-star",
  "bi-toggle-star-fill": "icons-module-scss-module__yaMlSa__bi-toggle-star-fill",
  "bi-toggle-star-half": "icons-module-scss-module__yaMlSa__bi-toggle-star-half",
  "bi-weather-cloud-fill": "icons-module-scss-module__yaMlSa__bi-weather-cloud-fill",
  "bi-weather-cloud-rain-fill": "icons-module-scss-module__yaMlSa__bi-weather-cloud-rain-fill",
  "bi-weather-cloud-sun-fill": "icons-module-scss-module__yaMlSa__bi-weather-cloud-sun-fill",
  "bi-weather-lightning-charge-fill": "icons-module-scss-module__yaMlSa__bi-weather-lightning-charge-fill",
  "bi-weather-moon-stars-fill": "icons-module-scss-module__yaMlSa__bi-weather-moon-stars-fill",
  "bi-weather-sun-fill": "icons-module-scss-module__yaMlSa__bi-weather-sun-fill",
  "bi-x": "icons-module-scss-module__yaMlSa__bi-x",
  "bi-x-circle-fill": "icons-module-scss-module__yaMlSa__bi-x-circle-fill",
  "bi-x-lg": "icons-module-scss-module__yaMlSa__bi-x-lg",
});
